import { $t } from '@i18n/utils';
import { ApiError } from '@shared/error/api.error';
import { RepositoryStrategyEnum } from 'src/shared/enum/repository-strategy.enum'

export abstract class Repository {
  protected repositoryStragtegy = this.setRepositoryStrategy();

  private setRepositoryStrategy(): RepositoryStrategyEnum {
    const mockOrder = process.env.DATASOURCE_ORDER.mock > 0 ? process.env.DATASOURCE_ORDER.mock : null
    const localOrder = process.env.DATASOURCE_ORDER.local > 0 ? process.env.DATASOURCE_ORDER.local : null
    const remoteOrder = process.env.DATASOURCE_ORDER.remote > 0 ? process.env.DATASOURCE_ORDER.remote : null

    if (mockOrder !== null) {
      return RepositoryStrategyEnum.MOCK
    } else if (localOrder && remoteOrder && localOrder < remoteOrder) {
      return RepositoryStrategyEnum.LOCAL_FIRST
    } else if (localOrder && remoteOrder && localOrder > remoteOrder) {
      return RepositoryStrategyEnum.NETWORK_FIRST
    } else if (localOrder && !remoteOrder) {
      return RepositoryStrategyEnum.LOCAL_ONLY
    } else if (!localOrder && remoteOrder) {
      return RepositoryStrategyEnum.NETWORK_ONLY
    } else {
      return RepositoryStrategyEnum.MOCK
    }
  }

  protected manageUnknownError(isOnline?: boolean): ApiError {
    if (isOnline === true) {
      return new ApiError($t('generic.unknownError'))
    } else {
      return new ApiError($t('generic.healthCheck.backendOffline'))
    }
  }
}
